import {useEffect} from 'react'

const useAriaHiddenOnIframes = () => {
    useEffect(() => {
        const setAriaHiddenOnIframes = () => {
            document.querySelectorAll('iframe').forEach((iframe) => {
                iframe.setAttribute('aria-hidden', 'true')
            })
        }
        setAriaHiddenOnIframes()
        const observer = new MutationObserver(setAriaHiddenOnIframes)
        observer.observe(document.body, {childList: true, subtree: true})
        return () => observer.disconnect()
    }, [])
}

export default useAriaHiddenOnIframes
